import '../App.css';
import NavBar from '../components/navbar';
import BrainImage from '../images/brain_image.png';
import ChatBot from '../images/chatbot.png';
import WorkFlow from '../images/manage.png';
import AIAgent from '../images/neural.png';
import SJBLogo from '../images/SJB.png';
import Call from '../images/call.png';
import Arrow from '../images/arrow.png';
import Develop from '../images/developing.png';
import Using from '../images/using.png';

import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

function HomePage() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            offset: 100,
        });
    }, []);


    const navigate = useNavigate()

    return (
        <div className="homepage">
            <NavBar />

            <div className="homepagemainsection">
                <div className="homepagemaintextsection">
                    <div className="tailoredAI"><b>Tailored AI Solutions</b></div>
                    <div className="subsection">
                        Drowning in repetitive work? <br />
                        Custom AI solutions designed to <br />
                        meet your businesses needs.
                    </div>
                    <div className="buttonsection">
                        <button className="consultationbutton" onClick={() => navigate('/consultation')}>Free Consultation</button>
                        <button className="learnmorebutton" onClick={() => navigate('/about')}>Learn More</button>
                    </div>
                </div>

                <div className="homepagemainimagesection">
                    <img className="brainimage" src={BrainImage} alt="brainimage" />
                </div>
            </div>

            <div className="ourservicessection" data-aos="fade-up">
                <div className="ourservicestext"><b>Our Services</b></div>
                <div className="servicesection">
                    <div className="servicecontainer" data-aos="zoom-in">
                        <img className="chatbotimage" src={ChatBot} alt="chatbotimage" />
                        <div className="custom"><b>Custom Chatbot</b></div>
                        <ul className="servicelist">
                            <li>Instant 24/7 support</li>
                            <li>Improves staff support</li>
                            <li>Improves lead capture and conversion rates</li>
                        </ul>
                    </div>

                    <div className="servicecontainer" data-aos="zoom-in" data-aos-delay="100">
                        <img className="chatbotimage" src={WorkFlow} alt="workflow" />
                        <div className="custom"><b>Workflow <br /> Automation</b></div>
                        <ul className="servicelist">
                            <li>Reduce repetitiveness</li>
                            <li>Reduces Error</li>
                            <li>Scales operation at low costs</li>
                        </ul>
                    </div>

                    <div className="servicecontainer" data-aos="zoom-in" data-aos-delay="200">
                        <img className="chatbotimage" src={AIAgent} alt="Agent" />
                        <div className="custom"><b>AI Agent </b></div>
                        <ul className="servicelist">
                            <li>Time savings for staff</li>
                            <li>24/7 Personal Assistant</li>
                            <li>Greater informed decision making</li>
                        </ul>
                    </div>
                </div>

                <div className="workedwith" data-aos="fade-up">
                    <div className="workedtext"><b>Proudly worked with</b></div>
                    <div className="workedwithimages">
                        <img className="SJBLogo" src={SJBLogo} alt="SJBLogo" />
                    </div>
                </div>
            </div>

            <div className="stepssection" data-aos="fade-up">
                <div className="works"><b>How it works</b></div>
                <div className="steps">
                    <div className="stepcontainer" data-aos="fade-up">
                        <img className="stepimage" alt="call" src={Call} />
                        <div className="steptext"><b>Step 1</b></div>
                        <div className="stepcontent">
                            Tell us about your business. We’ll explore smart, practical ways to integrate AI and help you save time, cut costs, and grow faster.
                        </div>
                    </div>

                    <img className="arrow" alt="arrow" src={Arrow} />

                    <div className="stepcontainer" data-aos="fade-up" data-aos-delay="100">
                        <img className="developimage" alt="develop" src={Develop} />
                        <div className="step2text"><b>Step 2</b></div>
                        <div className="stepcontent">
                            We create custom AI solutions designed around your business goals, with clear communication to stay true to your vision.
                        </div>
                    </div>

                    <img className="arrow" alt="arrow" src={Arrow} />

                    <div className="stepcontainer" data-aos="fade-up" data-aos-delay="200">
                        <img className="useimage" alt="use" src={Using} />
                        <div className="step3text"><b>Step 3</b></div>
                        <div className="stepcontent">
                            You use the AI. <br />
                            No complexity, just <br />
                            results.
                        </div>
                    </div>
                </div>

                <div className="letsbuild" style={{marginTop: '10%'}} data-aos="fade-up">
                    <div className="buildmaintext"><b>Lets Build your AI System</b></div>
                    <div className="buildsubheading"><b>Book a free consultation call</b></div>
                    <div className="consultbutton bottom" style={{ marginBottom: '10%' }} onClick={() => navigate('/consultation')}>Free Consultation</div>
                </div>
            </div>
        </div>
    );
}

export default HomePage;
